import { Store, useStore } from 'vuex';
import API from '../../api';

export interface CompanyTransactionsAdminStoreState {
  isLoading: boolean;
  isError: boolean;
  isDownloading: boolean;
  data: {
    company: any;
    transactions: any[];
  };
  meta: any;
  error?: any;
}

export const CompanyTransactionsAdminStoreImpl = {
  namespaced: true,

  state: (): CompanyTransactionsAdminStoreState => ({
    isLoading: false,
    isError: false,
    isDownloading: false,
    data: {
      company: {},
      transactions: []
    },
    meta: {}
  }),

  actions: {
    async updateState(
      { state }: { state: CompanyTransactionsAdminStoreState },
      args: { doUpdate: (state: CompanyTransactionsAdminStoreState) => Promise<any> }
    ) {
      return await args.doUpdate(state);
    }
  }
};

export class CompanyTransactionsAdminStore {
  private store: Store<any>;

  public constructor(store: Store<any> | undefined = null) {
    this.store = store ? store : useStore();
  }

  public get state(): CompanyTransactionsAdminStoreState {
    return this.store.state.companyTransactionsAdmin;
  }

  public dispatch<T>(doUpdate: (state: CompanyTransactionsAdminStoreState) => Promise<T>): Promise<T> {
    return this.store.dispatch('companyTransactionsAdmin/updateState', { doUpdate });
  }

  public async init(params: any) {
    this.dispatch(async (state) => {
      state.isLoading = true;
      try {
        const res = await API.get(`admin/companies/${params.company}/transactions`, params);
        const companyRes = await API.get(`admin/companies/${params.company}`);

        const data = {
          company: companyRes.data,
          transactions: res.data.data
        };

        for (const transaction of data.transactions) {
          if (transaction.car_id) {
            const carResponse = await API.get(`admin/cars/${transaction.car_id}`);

            transaction.car = carResponse.data;
          }
        }

        state.isLoading = false;
        state.data = data;
        state.meta = res.data.meta;
        state.isError = false;
        state.error = null;
      } catch (error) {
        state.isLoading = false;
        state.isError = true;
        state.error = error;
      }
    });
  }

  public async download(params: any) {
    this.dispatch(async (state) => {
      state.isDownloading = true;

      const res = await API.get(`admin/companies/${params.company}/transactions/download`, params);

      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(res.data));
      element.setAttribute('download', `export-${params.company}-${params.date_from}-${params.date_to}.csv`);

      element.style.display = 'none';
      document.body.appendChild(element);

      state.isDownloading = false;
      element.click();

      document.body.removeChild(element);
    });
  }
}
